<template>
  <div
    class="relative my-4 flex w-full cursor-pointer flex-col items-start rounded-md outline-none"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <label
      v-if="label"
      class="mb-1 text-left text-2xs font-bold uppercase"
      :class="[customClass]"
      :for="label"
    >
      {{ label }}
    </label>
    <div
      class="with-full flex h-12 w-full cursor-pointer items-center justify-between rounded-md border border-transparent bg-off-white text-sm text-body-color hover:border-placeholder-gray"
      :class="[{ open: open }, { 'light-bg': light }]"
      style="padding: 15px 0px 15px 24px"
      @click="open = !open"
    >
      {{ isObject ? selected?.value : selected }}
      <img
        class="mr-2 h-8 w-8 transition"
        :class="{ '-rotate-180 transform': open }"
        src="@/assets/arrow-down-black.svg"
        alt="arrow icon"
      />
    </div>
    <div
      class="absolute top-14 z-20 flex w-full flex-col items-start overflow-hidden rounded-b-md border-b border-l border-r border-body-color bg-white"
      :class="[{ hidden: !open }, { light: changePosition }]"
    >
      <div
        v-for="(option, i) of filterFor"
        :key="i"
        class="w-full text-left text-sm text-gray-over-dark hover:bg-off-white"
        style="padding: 15px 24px"
        :class="i === 0 ? 'mt-2' : ''"
        @click="
          selected = option;
          open = false;
          $emit('input', option);
        "
      >
        {{ isObject ? option?.value : option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownSelectPayment',
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: [String, Object],
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    label: String,
    customClass: {
      type: String,
      default: '',
    },
    isObject: {
      type: Boolean,
      default: false,
    },
    emitOnMount: {
      type: Boolean,
      default: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    changePosition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
          ? this.options[0]
          : null,
      open: false,
    };
  },
  computed: {
    filterFor: function () {
      return this.options.filter((el) => el !== this.selected);
    },
  },
  mounted() {
    if (this.emitOnMount) this.$emit('input', this.selected);
  },
};
</script>
<style scoped>
.open {
  @apply rounded-b-none rounded-t-md border-l border-r border-t border-black;
  background: #fff !important;
}
.open:hover {
  @apply border-body-color;
}

.light {
  top: 40px !important;
}

.light-bg {
  background: white !important;
}
</style>
